// MSG91 Web OTP Widget loader (default hosted UI, exposeMethods=false).
// Only the public widget id + widget token are used on the client.
// The private MSG91_AUTH_KEY lives on the backend and is never referenced here.
const SDK_URLS = [
  "https://verify.msg91.com/otp-provider.js",
  "https://verify.phone91.com/otp-provider.js",
];
let scriptPromise;

function loadScript() {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    if (typeof window.initSendOTP === "function") return resolve();
    let i = 0;
    const attempt = () => {
      const s = document.createElement("script");
      s.src = SDK_URLS[i];
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => {
        i += 1;
        if (i < SDK_URLS.length) attempt();
        else { scriptPromise = null; reject(new Error("Unable to load the OTP widget. Check your connection and try again.")); }
      };
      document.head.appendChild(s);
    };
    attempt();
  });
  return scriptPromise;
}

// Opens the MSG91 default OTP UI and resolves with the verified access token.
export async function startMsg91Login() {
  const widgetId = process.env.REACT_APP_MSG91_WIDGET_ID;
  const tokenAuth = process.env.REACT_APP_MSG91_WIDGET_TOKEN;
  if (!widgetId || !tokenAuth) {
    throw new Error("Mobile OTP login isn't configured yet. Please contact the administrator.");
  }
  await loadScript();
  if (typeof window.initSendOTP !== "function") {
    throw new Error("The OTP widget failed to initialize. Please try again.");
  }
  return new Promise((resolve, reject) => {
    window.initSendOTP({
      widgetId,
      tokenAuth,
      exposeMethods: false,
      success: (data) => {
        const token = data?.["access-token"] || data?.accessToken || data?.message;
        if (token && typeof token === "string") resolve(token);
        else reject(new Error("OTP was verified but no access token was returned."));
      },
      failure: (err) => reject(new Error((err && (err.message || err.msg)) || "OTP verification failed. Please try again.")),
    });
  });
}
